import { extendTheme, type ThemeConfig } from "@chakra-ui/react";

const config: ThemeConfig = {
  initialColorMode: "system",
  useSystemColorMode: false,
};

export const theme = extendTheme({
  config,
  fonts: {
    heading: "'Instrument Serif', 'Iowan Old Style', Georgia, serif",
    body: "'Geist', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif",
    mono: "'Geist Mono', ui-monospace, 'SF Mono', Menlo, monospace",
  },
  // Palette pulled from the yellow-green of the avatar portrait.
  semanticTokens: {
    colors: {
      bg: { default: "#fbfaf6", _dark: "#0e0f0c" },
      bgGlass: { default: "rgba(251, 250, 246, 0.82)", _dark: "rgba(14, 15, 12, 0.82)" },
      fg: { default: "#191a16", _dark: "#ecebe3" },
      muted: { default: "#66675e", _dark: "#9b9c90" },
      line: { default: "#e6e4dc", _dark: "#25261f" },
      accent: { default: "#4f6b07", _dark: "#cde34f" },
      accentSoft: { default: "rgba(79, 107, 7, 0.08)", _dark: "rgba(205, 227, 79, 0.08)" },
    },
  },
  styles: {
    global: {
      "html, body": {
        bg: "bg",
        color: "fg",
      },
      body: {
        fontSize: "1.0625rem",
        lineHeight: 1.65,
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale",
        textRendering: "optimizeLegibility",
      },
      "::selection": {
        bg: "accent",
        color: "bg",
      },
      // Inline links inside running text.
      ".prose a": {
        color: "fg",
        textDecoration: "underline",
        textDecorationColor: "var(--chakra-colors-accent)",
        textDecorationThickness: "1px",
        textUnderlineOffset: "3px",
        transition: "color 0.15s ease-out",
        _hover: {
          color: "accent",
        },
      },
      ".prose strong": {
        fontWeight: 600,
      },
      "@media (prefers-reduced-motion: reduce)": {
        "*, *::before, *::after": {
          animationDuration: "0.01ms !important",
          animationDelay: "0ms !important",
          animationIterationCount: "1 !important",
          transitionDuration: "0.01ms !important",
        },
      },
    },
  },
  components: {
    Heading: {
      baseStyle: {
        fontWeight: 400,
        letterSpacing: "-0.01em",
      },
    },
    Link: {
      baseStyle: {
        transition: "color 0.15s ease-out",
        _hover: {
          textDecoration: "none",
        },
      },
    },
  },
});
